import { Component, h, Listen, Event, EventEmitter, Prop, State } from '@stencil/core';
import { Customer } from '../../../globals/customer';
import { verifyOtp } from '../../../utils/verify-otp';
import { resendOtp } from '../../../utils/resend-otp';
import { CreateApplicationReturn, StatusCodeError } from '../../../utils';
import { VerifyIdentityTranslation } from '../../../globals/translations';
import { ErrorCodes } from '../../../globals/globals';
import { ErrorHelper } from '../../../helpers';

const successResponse = 'SUCCESS_RESPONSE';
const errorResponse = 'ERROR_RESPONSE';
const oneHalfSecond = 1500;

@Component({
  tag: 'validate-phone-state',
  styleUrl: './state-styles/validate-phone-state.scss',
  shadow: false,
})
export class ValidatePhoneState {
  @State() isLoading = false;
  @State() verifyPhoneResponse: string;

  @Prop() phone: string;
  @Prop({ mutable: true }) errors: ErrorHelper;
  @Prop({ mutable: true }) status: string;
  @Prop() translation: Partial<VerifyIdentityTranslation>;

  @Event() updateCustomer: EventEmitter<Partial<Customer>>;
  @Event() foundApplication: EventEmitter<CreateApplicationReturn>;
  @Event() continueClick: EventEmitter;

  @Listen('resendPhoneCode', { target: 'body' })
  async resendPhoneCode() {
    this.isLoading = true;

    try {
      await resendOtp();
    } catch (error) {
      this.errors.hasGenericError = true;
    }
    this.isLoading = false;
  }

  @Listen('validatePhoneCode', { target: 'body' })
  async validatePhoneCode(event: CustomEvent) {
    this.isLoading = true;
    this.verifyPhoneResponse = '';
    const code = event.detail;

    try {
      const resp = await verifyOtp(code);

      this.verifyPhoneResponse = !resp ? errorResponse : successResponse;

      setTimeout(() => {
        this.foundApplication.emit(resp);
      }, oneHalfSecond);
    } catch (error) {
      if (error instanceof StatusCodeError) {
        if (error.statusCode === ErrorCodes.Forbidden) {
          this.errors.hasFailedOtpError = true;

          return;
        }
      }
      this.errors.hasGenericError = true;
    } finally {
      this.isLoading = false;
    }
  }

  render() {
    const status = this.errors.hasFailedOtpError ? errorResponse : this.verifyPhoneResponse;

    return (
      <pc-verify-its-you status={status} phoneNumber={this.phone} isLoading={this.isLoading} translation={this.translation}>
        {this.errors.hasGenericError && <pc-generic-error slot="error-card" />}
      </pc-verify-its-you>
    );
  }
}
